import PropTypes from "prop-types";

import { t } from "../../../../../../services";
import { alignItems, strCode } from "../../../../../../consts";

import { FlexContainers, Paragraph2, WrapperContainer } from "../../../../../../components";

export const FirmwareSectionSummary = ({ firmwareSectionData }) => {
  const { selectedVersions } = firmwareSectionData ?? {};

  return firmwareSectionData ? (
    <WrapperContainer
      Container={FlexContainers.FlexColumnStart}
      alignItems={alignItems.start}
      gap={8}
      width={"100%"}>
      <Paragraph2>
        {t(strCode.VERSION_TITLE)} {selectedVersions[0]?.version?.value}
      </Paragraph2>
    </WrapperContainer>
  ) : null;
};

FirmwareSectionSummary.propTypes = {
  firmwareSectionData: PropTypes.shape({
    selectedVersions: PropTypes.arrayOf(
      PropTypes.shape({
        id: PropTypes.string.isRequired,
        version: PropTypes.shape({
          id: PropTypes.string.isRequired,
          value: PropTypes.string.isRequired
        })
      })
    ).isRequired
  })
};
